import { Grid, Stack } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import { Image } from '@bvi/common-components';
import loginFormBackground from '@bvi/dashboard/assets/loginFormBackground.jpg';

import { AppFooter } from '../AppFooter';

import { styles } from './styles';

export const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid container>
      <Grid item xs={6}>
        <Image src={loginFormBackground} sx={styles.backgroundImage} />
      </Grid>
      <Grid item xs={6}>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          px={2}
        >
          <Stack
            flex={1}
            justifyContent="center"
            width="100%"
            alignItems="center"
          >
            {children}
          </Stack>
          <AppFooter />
        </Stack>
      </Grid>
    </Grid>
  );
};
